export type CmsSaveToastState = {
  errorMessage: string | null;
  key: number;
  visible: boolean;
};

const HIDE_MS = 2200;
const ERROR_HIDE_MS = 4500;

let hideTimer: ReturnType<typeof setTimeout> | null = null;

export const useCmsSaveFeedback = () => {
  const toast = useState<CmsSaveToastState>("cms:saveToast", () => ({
    errorMessage: null,
    key: 0,
    visible: false,
  }));

  const resetHideTimer = (ms: number) => {
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      toast.value = { ...toast.value, visible: false };
      hideTimer = null;
    }, ms);
  };

  const showSuccess = () => {
    if (!import.meta.client) return;
    toast.value = {
      errorMessage: null,
      key: toast.value.key + 1,
      visible: true,
    };
    resetHideTimer(HIDE_MS);
  };

  const showError = (message: string) => {
    if (!import.meta.client) return;
    toast.value = {
      errorMessage: message,
      key: toast.value.key + 1,
      visible: true,
    };
    resetHideTimer(ERROR_HIDE_MS);
  };

  return {
    showError,
    showSuccess,
    toast: readonly(toast),
  };
};

/** Called from CMS API helpers after a successful write. */
export const notifyCmsSaved = () => {
  useCmsSaveFeedback().showSuccess();
};

export const notifyCmsSaveFailed = (message: string) => {
  useCmsSaveFeedback().showError(message);
};
